<div
  class="typography typography-headline typography-bold typography-paragraph grey-800 mt-48"
>
  Категории анализов
</div>

<div
  class="select select-green full-width"
  (click)="showCategoryModal()"
  ymGoal
  [nameGoal]="YmGoalCatalog.CategoryButtonClick"
>
  <span
    class="icon icon-24 icon-list green-600"
    data-testid="analysis-category-filter-button"
  ></span>
  {{ (repository.selectedCategory$ | async)?.description ?? "" }}
</div>

<!-- SEO -->
<div class="hidden">
  <a
    *ngFor="let category of repository.categories$ | async"
    [routerLink]="routeCatalog + category.urlPart"
  >
    {{ category.description }}
  </a>
</div>
